import Header from "../../components/layout/Header/Header";
import Footer from "../../components/layout/Footer/Footer";
import Container from "../../components/layout/Container/Container";

import s from "./PrivacyPolicyPage.module.scss";

import { useClinicInfo } from "../../api/queries/useClinicInfo";
import { toMap } from "../../app/clinicInfoMap";
import {
  DEFAULT_PRIVACY_POLICY_BODY,
  DEFAULT_PRIVACY_POLICY_TITLE,
  parsePrivacyPolicy,
  PRIVACY_POLICY_BODY_KEY,
  PRIVACY_POLICY_TITLE_KEY,
} from "../../app/privacyPolicy";

export default function PrivacyPolicyPage() {
  const { data, isLoading, isError } = useClinicInfo();
  const cfg = toMap(data ?? []);

  const hasDbData = !isLoading && !isError && (data?.length ?? 0) > 0;

  const title =
    ((cfg[PRIVACY_POLICY_TITLE_KEY] as string | undefined) || "").trim() ||
    DEFAULT_PRIVACY_POLICY_TITLE;

  const body =
    ((cfg[PRIVACY_POLICY_BODY_KEY] as string | undefined) || "").trim() ||
    DEFAULT_PRIVACY_POLICY_BODY;

  const sections = parsePrivacyPolicy(body);
  const usingFallback =
    !hasDbData ||
    !((cfg[PRIVACY_POLICY_TITLE_KEY] || "").trim() && (cfg[PRIVACY_POLICY_BODY_KEY] || "").trim());

  return (
    <div className={s.pageWrap}>
      <Header />

      <main className={s.main}>
        <section className="section section--tight">
          <Container>
            <div className={s.panel}>
              <h1 className={s.h1}>{title}</h1>

              {usingFallback ? (
                <div className={s.meta}>
                  Сейчас показан текст по умолчанию. В админке можно задать свой заголовок и полный
                  текст политики.
                </div>
              ) : null}

              <div className={s.doc}>
                {sections.map((section) => (
                  <section key={`${section.number}_${section.title}`} className={s.sectionCard}>
                    <h2 className={s.sectionTitle}>
                      {section.number}. {section.title}
                    </h2>

                    <div className={s.items}>
                      {section.items.map((item, idx) => (
                        <p key={`${item.number}_${idx}`} className={s.item}>
                          {item.number ? (
                            <>
                              <span className={s.itemNumber}>{item.number}.</span>{" "}
                              <span>{item.text}</span>
                            </>
                          ) : (
                            <span>{item.text}</span>
                          )}
                        </p>
                      ))}
                    </div>
                  </section>
                ))}
              </div>
            </div>
          </Container>
        </section>
      </main>

      <Footer />
    </div>
  );
}